module.exports = __webpack_public_path__ + "static/media/SF-6-A.3f776f6c.mp3";